// Crop Plantings
export const CROPS_PLANTING_LIST_VIEW = "/crop-plantings"
export const NEW_CROP_PLANTING_VIEW = CROPS_PLANTING_LIST_VIEW + "/new"
export const CROP_PLANTING_VIEW = `${CROPS_PLANTING_LIST_VIEW}/:cropPlantingId`
export const EDIT_CROP_PLANTING_VIEW = `${CROP_PLANTING_VIEW}/edit`

// Crops
export const CROPS_LIST_VIEW = "/crops"
export const CROP_VIEW = `${CROPS_LIST_VIEW}/:cropId`
